
import { createAsyncActionCreator, IAsyncActionCreator, IDispatch } from '../store/actions/createActionCreator';
import { currentItemFacet } from '../facets/ScopeFacets';
import { waitForNextStoreUpdate } from '../store/enhancers/NextStoreUpdateEnhancer';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { IFaceted } from '../models/Facet';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { resolveItems } from './getItems';

export const openItem = createAsyncActionCreator((payload: {
  itemsScopeItemKey: string;
  currentItemKey: string;
}): IItemCacheThunkAction<Promise<void>> => {
  const {
    itemsScopeItemKey,
    currentItemKey
  } = payload;

  return async (dispatch: IItemCacheDispatch) => {
    dispatch(resolveItems({
      items: {
        [itemsScopeItemKey]: {
          ...currentItemFacet.pack({
            itemKey: currentItemKey
          })
        }
      }
    }));

    await dispatch(waitForNextStoreUpdate());
  };
});

// @ts-ignore
type __unused_declarations = Pick<
  IDispatch<never> |
  IAsyncActionCreator<never, never> |
  IFaceted |
  IItemCacheState,
  never>;
